import { render, staticRenderFns } from "./edit-parameter.vue?vue&type=template&id=1030c5e8&scoped=true&"
import script from "./edit-parameter.vue?vue&type=script&lang=ts&"
export * from "./edit-parameter.vue?vue&type=script&lang=ts&"
import style0 from "./edit-parameter.vue?vue&type=style&index=0&id=1030c5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1030c5e8",
  null
  
)

export default component.exports